import Bpage5 from "../../components/blog-pages/Bpage5";
import Header from "../../components/Header";
import Sobre from "../../components/Sobre";

function Page5() {
    return (
        <div>
            <Header isComunicacao={false}></Header>
            <Bpage5></Bpage5>
            <Sobre></Sobre>
        </div>
    )

}

export default Page5;